import { PerceptualHistogram } from './PerceptualHistogram.js';
export class ToneCurveMatcher {
    pointCount;
    constructor(pointCount = 16) {
        this.pointCount = pointCount;
    }
    match(referenceHistogram, sourceHistogram) {
        const reference = new PerceptualHistogram(referenceHistogram.length, referenceHistogram);
        const source = new PerceptualHistogram(sourceHistogram.length, sourceHistogram);
        return Array.from({ length: this.pointCount }, (_, index) => {
            const input = index / Math.max(1, this.pointCount - 1);
            const referenceValue = reference.quantile(input);
            const sourceValue = source.quantile(input);
            return Number(Math.max(-1, Math.min(1, referenceValue - sourceValue)).toFixed(4));
        });
    }
}
//# sourceMappingURL=ToneCurveMatcher.js.map